import React, { useEffect, useState, useRef } from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SlotStyles from "../styles/slot";

function VideoSlot(props) {
    const navigate = useNavigate();

    const textRef = useRef(null);

    const [text, setText] = useState();
    const [textOverflow, setTextOverflow] = useState(false);

    useEffect(() => {
        setText(props.title);
    }, []);

    useEffect(() => {
        if (textRef != null) {
            if (textRef.current.scrollHeight > textRef.current.offsetHeight + 2) {
                setText(`${text.substring(0, 30)}...`);
                setTextOverflow(true);
            }
        }
    }, [text]);

    return (
        <div style={SlotStyles.video_cardBody}>
            <div style={SlotStyles.video_cardImage}>
                <Image src={props.thumbnail} style={SlotStyles.image} onClick={props.onClick.bind(this, props.videoURL)} />
            </div>
            {textOverflow ? (
                <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.title}</Tooltip>}>
                    <div ref={textRef} style={SlotStyles.video_cardText}>
                        {text}
                    </div>
                </OverlayTrigger>
            ) : (
                <div ref={textRef} style={SlotStyles.video_cardText}>
                    {text}
                </div>
            )}
        </div>
    );
}

export default VideoSlot;
